var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "espacamento", attrs: { shadow: "hover" } },
        [
          _c("div", { staticClass: "cardHeader" }, [
            _c("b", [_vm._v("Dados do Documento:")])
          ]),
          _c("div", { attrs: { id: "line" } }),
          _vm.exibeObs
            ? _c("p", { staticStyle: { color: "red", "font-size": "13px" } }, [
                _vm._v(
                  "Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI)."
                )
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Nome/Razão Social:",
                      content:
                        _vm.cadastro.dados.cadastro.interessado.pessoa
                          .pessoaFisica.nome,
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "CPF/CNPJ:",
                      content:
                        _vm.cadastro.dados.cadastro.interessado.pessoa
                          .pessoaFisica.cpf,
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Endereço:",
                      content:
                        _vm.cadastro.dados.cadastro.interessado.pessoa.endereco
                          .logradouro,
                      contentAlignRight: false
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Telefone:",
                      content:
                        _vm.cadastro.dados.cadastro.interessado.pessoa
                          .telefones[0],
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "N° Processo:",
                      content: _vm.dadosVtn.processo.numeroProcesso,
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Data Emissão:",
                      content: _vm.getDataFrmatada(_vm.dadosVtn.dataEmicao),
                      contentAlignRight: false
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Município:",
                      content: _vm.getNomeMunicipio(),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Data Vencimento:",
                      content: _vm.getDataFrmatada(_vm.dadosVtn.dataVencimento),
                      contentAlignRight: false
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "cardHeader" }, [
            _c("b", [_vm._v("Dados dos fatores de redução:")])
          ]),
          _c("div", { attrs: { id: "line" } }),
          _vm.exibeObs
            ? _c("p", { staticStyle: { color: "red", "font-size": "13px" } }, [
                _vm._v(
                  "Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI)."
                )
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Tempo de Ocupação (anos):",
                      content: _vm.dadosVtn.tempoOcupacao,
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Eletrificação Rural:",
                      content: _vm.cadastro.dados.cadastro.imovel
                        .possuiEletrificacao
                        ? "Sim"
                        : "Não",
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "Distância da Capital Boa Vista em Linha Reta (km):",
                      content: _vm.dadosVtn.distanciaBoaVista,
                      contentAlignRight: false
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Área Reserva Legal:",
                      content: _vm.areaReservalegalProcentagem,
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Acesso por Rodovia RR/BR Pavimentado:",
                      content:
                        _vm.cadastro.dados.cadastro.imovel
                          .possuiAcessoRodovia &&
                        _vm.cadastro.dados.cadastro.imovel.isRodoviaPavimentada
                          ? "Sim"
                          : "Não",
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "Interesse Ecológico Para a Preservação dos Ecossistemas:",
                      content: _vm.cadastro.dados.cadastro.imovel
                        .interessesEcologicos
                        ? "Sim"
                        : "Não",
                      contentAlignRight: false
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Conduta ou Atividade Lesiva ao Meio Ambiente:",
                      content: _vm.dadosVtn.condutaLesivaMeioAmbiente
                        ? "Sim"
                        : "Não",
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Acesso por vicinais:",
                      content: _vm.cadastro.dados.cadastro.imovel
                        .isRodoviaVicinais
                        ? "Sim"
                        : "Não",
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Projeto de Recuperação de Áreas Degradadas:",
                      content: _vm.cadastro.dados.cadastro.imovel
                        .possuiProjetoRecuperacao
                        ? "Sim"
                        : "Não",
                      contentAlignRight: false
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "cardHeader" }, [
            _c("b", [_vm._v("Resumo dos dados do cálculo:")])
          ]),
          _c("div", { attrs: { id: "line" } }),
          _vm.exibeObs
            ? _c("p", { staticStyle: { color: "red", "font-size": "13px" } }, [
                _vm._v(
                  "Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI)."
                )
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Somatório dos Fatores de Redução:",
                      content: _vm.getValor(
                        _vm.dadosVtn,
                        "somatorioDosConficientesFormatado"
                      ),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor do VTN Para Área em Uso:",
                      content: _vm
                        .getValorNumerico(
                          _vm.dadosVtn,
                          "municipio; valorReferencia"
                        )
                        .toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL"
                        }),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor do VTN Para Área de Reserva Legal:",
                      content: _vm
                        .getValorNumerico(_vm.dadosVtn, "vtnAreaReservaLegal")
                        .toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL"
                        }),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor Total do Imóvel:",
                      content: _vm.dadosVtn.valorFinalImovelFormatado,
                      contentAlignRight: false
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Porcentagem Máxima Para Redução (%):",
                      content: _vm.getValor(
                        _vm.dadosVtn,
                        "porcentagemMaximaReducaoFormatada"
                      ),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "VTNt: Para Área em Uso(R$/ha):",
                      content: _vm
                        .getValorNumerico(_vm.dadosVtn, "vtntAreaUso")
                        .toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL"
                        }),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "VTNt: Para Área de Reserva Legal(R$/ha)",
                      content: _vm
                        .getValorNumerico(_vm.dadosVtn, "vtntReservaLegal")
                        .toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL"
                        }),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor Total do Imóvel a Vista (R$):",
                      content: _vm.dadosVtn.valorAVistaFormatado,
                      contentAlignRight: false
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Porcentagem Aplicável Para Redução:",
                      content: _vm.getValor(
                        _vm.dadosVtn,
                        "percentualAplicadoFormatado"
                      ),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor do Imóvel em Relação a Área em Uso:",
                      content: _vm
                        .getValorNumerico(_vm.dadosVtn, "vtnAreaUso")
                        .toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL"
                        }),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label:
                        "Valor do Imóvel em Relação a Área de Reserva Legal:",
                      content: _vm
                        .getValorNumerico(_vm.dadosVtn, "vtnReservaLegal")
                        .toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL"
                        }),
                      contentAlignRight: false
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.exibeCardObs
        ? _c("observacoesRR", { staticClass: "espacamento" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bb74052", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bb74052","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/ConfirmarDadosRR.vue
// module id = null
// module chunks = 